var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v(_vm._s(_vm.title))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body p-0" },
      [
        [
          _c("v-data-table", {
            staticClass: "elevation-1 table-sm",
            attrs: {
              headers: _vm.headers,
              items: _vm.data,
              "hide-default-footer": "",
              dense: "",
              "item-class": _vm.BACKGROUND,
              "items-per-page": -1,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.id",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.type) +
                          _vm._s(item.id) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.pieces",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(Number(item.pieces || 0).toFixed(2)) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.description",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "mx-1",
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    Array.isArray(item.description)
                                      ? _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              { staticClass: "nowrap" },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(item.description[0]) +
                                                " ...\n                            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "small",
                            _vm._l(
                              item.description,
                              function (description, key) {
                                return _c("div", { key: key }, [
                                  _vm._v(_vm._s(description)),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.lengthy",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(Number(item.lengthy || 0).toFixed(2)) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.width",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(Number(item.width || 0).toFixed(2)) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.tall",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(Number(item.tall || 0).toFixed(2)) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.weight",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(Number(item.weight || 0).toFixed(2)) +
                          "\n                "
                      ),
                    ]
                  },
                },
                {
                  key: "item.volumetric_weight",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            Number(item.volumetric_weight || 0).toFixed(2)
                          ) +
                          "\n                "
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }